import { Popup } from '@progress/kendo-react-popup'
import { useAppContext } from 'context/AppContext'
import { useAuth } from 'context/AuthContext'

type UpsellPopupProp = {
    popup_ref: any
    show_popup: any
    setShowPopup: any
    type: string
}

function UpsellPopup(props: UpsellPopupProp) {
    const { UpsellModal } = useAuth()
    const { translations } = useAppContext()
    return (
        <Popup
            anchor={props.popup_ref}
            show={props.show_popup}
            popupAlign={{
                horizontal: 'left',
                vertical: 'top',
            }}
            animate={false}
            popupClass={'border p-5 w-72'}
            className="z-[102]"
        >
            <p className="text-md font-medium text-left">
                {translations['upgrade_plan_needed']}
            </p>
            <p className="text-left mt-2">
                {translations[`no_access_${props.type}_functionality`]}
            </p>
            <div className="flex gap-3 mt-4">
                <button
                    className="bg-primary rounded-lg text-white text-sm flex-1 btn-gap"
                    onClick={() => {
                        props.setShowPopup(false)
                        UpsellModal.open()
                    }}
                >
                    {translations['upgrade']}
                </button>
                <button
                    className="text-sm flex-1 "
                    onClick={() => {
                        props.setShowPopup(false)
                    }}
                >
                    {translations['ill_check_later']}
                </button>
            </div>
        </Popup>
    )
}

export default UpsellPopup
